import { pdfDownloadSuccess } from "../../../assets/imageImport";

export const DownloadMailSuccess = () => {
  return (
    <div className="col-lg-12" id="mailsentsuccess" style={{ display: "none" }}>
      <div className="dowloadPro-success">
        <div>
          <img src={pdfDownloadSuccess} alt="Download Success" />
        </div>
        <div className="dowloadPro-success-info">
          <h5>Success!</h5>
          <p>
            Thanks for your download enquiry. Our Customer Sales Team will be in
            contact with you Shortly.
          </p>
        </div>
      </div>
    </div>
  );
};
